module.exports = __webpack_public_path__ + "static/img/10.fb7ba9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/10.png
// module id = Yw7E
// module chunks = 0